import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { PipesModule } from '../../../shared/pipes/pipes.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { createTranslateLoader } from '../../../shared/http-loader-factory';
import { HttpClient } from '@angular/common/http';
import { UploadFileWithProgressComponent } from './upload-file-with-progress.component';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
    imports: [
        CommonModule,
        MatProgressBarModule,
        PipesModule,
        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient],
            },
        }),
      MatIconModule,
    ],
  declarations: [UploadFileWithProgressComponent],
  exports: [UploadFileWithProgressComponent],
})
export class UploadFileWithProgressModule {}
